'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactRouter = require('react-router');


var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _TopBlock = require('./TopBlock.scss');var _TopBlock2 = _interopRequireDefault(_TopBlock);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // import { PackagePromotion } from '../../../../components';

var TopBlock = function TopBlock(properties) {var
  translate = properties.translate,isRtl = properties.isRtl,userProperties = properties.userProperties,title = properties.title,clickPackageUpdate = properties.clickPackageUpdate;

  var propertiesData = (0, _get2.default)(userProperties, 'data.meta.' + properties.getProperties, {});
  var restrictionToAddProperties = (0, _get2.default)(
  userProperties, 'data.meta.' +
  properties.getProperties + '.restriction_to_add_properties.' + properties.getProperties) ||
  (0, _get2.default)(
  userProperties, 'data.meta.restriction_to_add_properties.' +
  properties.getProperties) ||
  {};

  // user_foreign_properties
  var active = propertiesData.active,allowed = propertiesData.allowed,allowedUntil = propertiesData.allowed_until;

  var allowedToPublish = void 0;
  if (restrictionToAddProperties.restricted) {
    allowedToPublish = restrictionToAddProperties.count;
  } else {
    allowedToPublish = allowed - active;
  }

  var today = (0, _moment2.default)();
  var allowedUntilDate = (0, _moment2.default)(allowedUntil);
  var untilDate = '-';

  if (allowedUntil) {
    if (today < allowedUntilDate) {
      untilDate = allowedUntilDate.utc().format('DD/MM/YYYY');
    }
  }

  var daysDiff = allowedUntilDate.diff(today, 'days') > 0 ? allowedUntilDate.diff(today, 'days') : '';

  return (
    _react2.default.createElement('div', { className: _TopBlock2.default.flexPosition },
      _react2.default.createElement('div', { className: _TopBlock2.default.userData },
        _react2.default.createElement('div', { className: _TopBlock2.default.packageName }, title),
        _react2.default.createElement('div', { className: _TopBlock2.default.validUntilWrapper },
          _react2.default.createElement('span', { className: _TopBlock2.default.topBlockText },
            translate('managePage', 'validUntil') + ': ',
            _react2.default.createElement('span', null,
              untilDate)),


          _react2.default.createElement('div', {
              className: _TopBlock2.default.days }, ' ' +

            daysDiff + ' ' + translate('managePage', 'daysLeft')))),



      _react2.default.createElement('div', { className: _TopBlock2.default.userData },
        _react2.default.createElement('div', { className: _TopBlock2.default.remainingProps },
          _react2.default.createElement('span', { className: _TopBlock2.default.topBlockText }, translate('managePage', 'remainingProperties') + ':  ', ' '),
          _react2.default.createElement('span', { className: _TopBlock2.default.boldText }, '\xA0' + allowedToPublish + ' ' + translate('managePage', 'of') + ' ' + allowed))),


      _react2.default.createElement('button', {
          className: _TopBlock2.default.updateBtn,
          onClick: clickPackageUpdate },

        _react2.default.createElement('span', { className: 'icon icon-rotate' },
          _react2.default.createElement('span', { className: 'path1' }),
          _react2.default.createElement('span', { className: 'path2' }),
          _react2.default.createElement('span', { className: 'path3' }),
          _react2.default.createElement('span', { className: 'path4' }),
          _react2.default.createElement('span', { className: 'path5' })),

        _react2.default.createElement('span', { className: _TopBlock2.default.updateBtnText }, translate('managePage', 'packageUpdate')))));



};exports.default =

TopBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ManagePropertiesForAgent/components/TopBlock.js
// module id = 2985
// module chunks = 0